// extracted by mini-css-extract-plugin
module.exports = {"Button":"QI7b2B9HFdWRqXJlhx5ZF","error":"tZCD8VOqjh9hYl64FL-I_","success":"_3d-85UZAqA-Esfbxli0-3P","primary":"_2Lss2gI0QSqIPLlJasQz5F"};